<template>
	<v-layout
		v-if="!compensation"
		:row="row"
		:column="!row"
		:align-start="commicement"
		class="mb-4"
		wrap
	>
		<v-flex md12>
			<p class="body-1">
				Auf der Grundlage der von Ihnen bereitgestellten Informationen könnte
				eine Kündigungsschutzklage Erfolg haben. Nennen Sie uns nun Ihr
				Bruttomonatsgehalt und wir berechnen die mögliche Höhe Ihrer Abfindung:
			</p>
		</v-flex>
		<v-flex v-if="!lCommicement">
			<commence-date></commence-date>
		</v-flex>
		<v-flex>
			<v-text-field
				v-model="grossSalary"
				label="Bruttomonatsgehalt"
				:class="{ 'mx-4': !lCommicement && row, 'mx-2': !row }"
			></v-text-field>
		</v-flex>
		<v-flex>
			<v-btn id="btn-calculate" color="primary" @click="calc()"
				>Berechnen</v-btn
			>
		</v-flex>
		<v-flex md12>
			<p class="body-1">
				<strong>Hinweis</strong>: Als Bruttomonatsgehalt gilt, was Ihnen bei der
				für Sie maßgeblichen regelmäßigen Arbeitszeit in dem Monat, in dem das
				Arbeitsverhältnis endet, an Geld und Sachbezügen zusteht. Als
				Untergrenze gilt der gesetzliche Mindestlohn.
			</p>
		</v-flex>
	</v-layout>
	<div v-else>
		<p>Die Höhe Ihrer Abfindung beträgt:</p>
		<p class="display-2 primary--text">
			{{
				compensation.toLocaleString('de-DE', {
					style: 'currency',
					currency: 'EUR',
				})
			}}
		</p>
		<p class="body-1">
			<strong>Hinweis</strong>: Beachten Sie, dass eine Klagefrist von drei
			Wochen ab Zugang der schriftlichen Kündigung gilt. Warten Sie also nicht
			zu lange und setzen Sie sich mit uns in Verbindung. Wir beraten Sie
			kostenlos und unverbindlich zum weiteren Vorgehen.
		</p>
	</div>
</template>

<script>
import * as moment from 'moment';
import { mapState } from 'vuex';

import CommenceDate from './CommenceDate.vue';

export default {
	props: ['item'],
	components: {
		CommenceDate,
	},
	computed: {
		...mapState(['commicement']),
		row() {
			return this.$vuetify.breakpoint.smAndUp;
		},
	},
	methods: {
		calc() {
			const inputDate = moment(this.commicement);
			const months = moment().diff(inputDate, 'months');

			this.compensation = (this.grossSalary / 2) * (months / 12);
		},
		sendMessage() {
			var hght = 0;
			if (document.body.offsetHeight < 380) {
				hght = 380;
			} else {
				hght = Math.max(
					document.body.offsetHeight,
					document.documentElement.offsetHeight
				);
			}
			window.parent.postMessage(
				{
					event: 'resize-calc',
					height: hght,
				},
				'*'
			);
		},
	},
	updated() {
		this.sendMessage();
	},
	created() {
		this.lCommicement = this.commicement;
		let self = this;
		window.setTimeout(function () {
			self.sendMessage();
		}, 200);
	},
	data: () => ({
		compensation: null,
		grossSalary: null,
	}),
};
</script>
